import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useRootStore } from 'stores/use-root-store';

// TODO: we need to revalidate this logic accordingly to the other cases to avoid potential conflicts
export const useSetActivePetFromQuery = (): void => {
  const selectPetProfile = useRootStore((store) => store.selectPetProfile);
  const customerPets = useRootStore((store) => store.customerPets);
  const isCustomerPetsLoaded = useRootStore((store) => store.isCustomerPetsLoaded);
  const { isReady, query, pathname, replace } = useRouter();
  const { id: petId } = query;

  /**
   * Switch to the specified pet when ID is provided in the URL
   * and clean up the query parameter afterwards
   */
  useEffect(() => {
    // wait until customerPets is known-loaded so `?id=<savedPetId>` deep-links on fresh sessions
    // don't no-op against an empty pre-hydration array
    if (!isCustomerPetsLoaded) return;

    if (isReady && typeof petId === 'string') {
      selectPetProfile({ petProfileId: petId });

      // `?id=` is overloaded across the app (subscription id on /futterabo, etc.) and this hook runs globally,
      // so we only act when the id matches an existing profile in customerPets. Renaming the pet-profile param to  `petId`
      // would remove the overload but there is alignment needed with marketing team
      const isPetProfileId = customerPets.some((petProfile) => petProfile.id === petId);
      if (!isPetProfileId) return;

      // Clean up the URL by removing the id parameter while keeping other query params
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { id: _id, ...updatedQuery } = query;
      replace(
        {
          pathname,
          query: updatedQuery,
        },
        undefined,
        { shallow: true }
      );
    }
  }, [
    customerPets,
    isCustomerPetsLoaded,
    isReady,
    pathname,
    petId,
    query,
    replace,
    selectPetProfile,
  ]);
};
